import React from "react";

function RightArrowIcon() {
  return (
    <span className="fullPage_leftMenu_menu_rightArrow">

<svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
      className="neededStroke"
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.339"
        d="M4.948 8.711l2.678-2.678-2.678-2.677"
      ></path>
    </svg>
    </span>
   
  );
}

export default RightArrowIcon;